import { GetAllChatMessage } from '~/domain/usecases/chat/remote';
import {
  InvalidCredentialsError,
  UnexpectedError,
  BadRequestError,
  NotFound,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteGetAllChatMessage implements GetAllChatMessage {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetAllChatMessage.Model>;

  constructor(url: string, httClient: HttpClient<GetAllChatMessage.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  getAllMessage = async (
    params: GetAllChatMessage.Params,
  ): Promise<GetAllChatMessage.Model> => {
    let query = '';
    Object.entries(params).forEach(([key, value]) => {
      if (key !== 'chatId') {
        query += `${key}=${value}&`;
      }
    });

    const httpResponse = await this.httpClient.request({
      url: `${this.url}?${query}`.replace('{chatId}', `${params.chatId}`),
      method: 'get',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  };
}
